import {
    Col,
    Container,
    Row,
    Card,
    Form,
    Alert,
    Button,
} from "react-bootstrap";
import TpmrForm from "./TpmrForm";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useCallback, useEffect, useState } from "react";
import api from "../../../../../service/api";
import { SnackbarAlert } from "../../../../../components/SnackbarAlert";
import { ArrowLeft } from "react-feather";

const AddEditTpmrPage = () => {
    const { id } = useParams();
    const [searchParams] = useSearchParams();
    const batchId = searchParams.get("batchId");
    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const [enrolment, setEnrolment] = useState(null);
    const [batch, setBatch] = useState(null);
    const [notif, setNotif] = useState({
        notifMsg: "",
        open: false,
        severity: "success",
    });

    const getData = useCallback(async () => {
        setLoading(true);
        try {
            const [enrolmentRes, batchRes] = await Promise.all([
                await api.get(`tms/enrolments/${id}`, {}),
                await api.get(`tms/batches/${batchId}`, {}),
            ]);
            setEnrolment(enrolmentRes.data);
            setBatch(batchRes.data);
            setLoading(false);
        } catch (error) {
            console.error(error);
            setError("Something went wrong... Try again later...");
        } finally {
            setLoading(false);
        }
    }, [id, batchId]);

    useEffect(() => {
        getData();
    }, [getData]);

    const formInfo = {
        courseName: enrolment?.course?.name,
        courseOptions: JSON.parse(enrolment?.course?.tpmr_option ?? "[]"),
        trainingDates: enrolment?.training_dates,
        adhocTrainingDates: batch?.adhoc_training_dates,
        enrolmentId: enrolment?.id,
        studentId: enrolment?.student_id,
        batchId,
        notif,
        setNotif,
    };

    return (
        <>
            <Container fluid className="p-0">
                <Row className="g-4 px-5">
                    <Card className="p-3 shadow-sm h-100">
                        <Row className="align-items-center mb-3">
                            <Col>
                                <h3 className="fw-semibold m-0">
                                    Trainee Performance Evaluation
                                </h3>
                            </Col>

                            <Col className="text-end">
                                <Button
                                    variant="info"
                                    onClick={() =>
                                        navigate(
                                            `/tms/batches/students-tpmr/${batchId}`
                                        )
                                    }
                                >
                                    <ArrowLeft className="feather me-1" />
                                </Button>
                            </Col>
                        </Row>

                        <Row>
                            <h3 className="fw-semibold pb-2">
                                Candidate Details
                            </h3>
                        </Row>
                        {loading ? (
                            <div>Loading...</div>
                        ) : (
                            <>
                                <Row>
                                    {error && (
                                        <div className="px-3">
                                            <Alert variant="danger">
                                                <div className="alert-message">
                                                    {error}
                                                </div>
                                            </Alert>
                                        </div>
                                    )}

                                    <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Name</Form.Label>
                                            <Form.Control
                                                placeholder="Enter Practical Type"
                                                value={enrolment?.name || "-"}
                                                readOnly
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Fin</Form.Label>
                                            <Form.Control
                                                placeholder="Enter Practical Type"
                                                value={enrolment?.fin || "-"}
                                                readOnly
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Label>
                                                Contact Number
                                            </Form.Label>
                                            <Form.Control
                                                placeholder="Enter Practical Type"
                                                value={
                                                    enrolment?.contact_number ||
                                                    "-"
                                                }
                                                readOnly
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <TpmrForm {...formInfo} />
                            </>
                        )}
                    </Card>
                </Row>
            </Container>
            <SnackbarAlert notif={notif} setNotif={setNotif} />
        </>
    );
};

export default AddEditTpmrPage;
